import React, { useState, useEffect } from "react";
import "./style.scss";
import Slider from "@mui/material/Slider";
import PropTypes from "prop-types";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import AccessibleCarousel from "../Carousel/AccessibleCarousel.jsx";
import {
  resetZoomOnFloorChange,
  applyZoomEffect,
  handleZoomIn,
  handleZoomOut,
  handleResetZoom,
  handleFullScreen,
  handleExitFullScreen,
  handleEscapeKey,
  handleSliderChange,
} from "../../utils/footerUtils.js";

const Footer = ({ floorMapRef, currentFloor, expand, isDynamicFooter, carouselItems }) => {
  const [zoomLevel, setZoomLevel] = useState(100);
  const [announcement, setAnnouncement] = useState(`Zoom ${zoomLevel} percent`);

  // Reset zoom when floor changes
  useEffect(() => {
    resetZoomOnFloorChange(setZoomLevel);
  }, [currentFloor]);

  // Apply zoom effect to floor map
  useEffect(() => {
    applyZoomEffect(floorMapRef, zoomLevel);
  }, [zoomLevel, floorMapRef]);

  return (
    <section
      className="footer_wrapper"
      aria-label="Footer Controls"
      // onWheel={(e) => handleWheel(e, (ev) => handleZoomIn(ev, setZoomLevel, zoomLevel, setAnnouncement), (ev) => handleZoomOut(ev, setZoomLevel, zoomLevel, setAnnouncement))}
      // onKeyDown={(e) => handleKeyDown(e, (ev) => handleZoomIn(ev, setZoomLevel, zoomLevel, setAnnouncement), (ev) => handleZoomOut(ev, setZoomLevel, zoomLevel, setAnnouncement))}
      style={{ outline: "none", justifyContent: isDynamicFooter ? "center" : "space-between" }}
    >
      <AccessibleCarousel items={carouselItems} itemsToShow={6} timeInterval={5000} customClass="centerMenu" />

      {!isDynamicFooter && (
        <div className="rightMenu">
          <div className="zoomhead">Zoom: {zoomLevel}%</div>

          <div aria-live="polite" aria-atomic="true" className="sr-only" role="status">
            {announcement}
          </div>

          <div>
            <AccessibleTooltip title="Zoom Out">
              <button
                className="zoom_out"
                onClick={(e) => handleZoomOut(e, setZoomLevel, zoomLevel, setAnnouncement)}
                type="button"
                aria-label="Zoom Out"
              ></button>
            </AccessibleTooltip>
          </div>

          <div style={{ position: "relative" }}>
            <Slider
              size="small"
              value={zoomLevel}
              min={50}
              max={200}
              step={10}
              onChange={(e, val) => handleSliderChange(e, val, setZoomLevel)}
              valueLabelFormat={(value) => `${value}%`}
              aria-label="Zoom"
              className="footer-slider"
              getAriaValueText={(value) => `${value} percent`}
              sx={{
                color: "#1976d2",
                "& .MuiSlider-rail": { backgroundColor: "#B1D1E6" },
                "& .MuiSlider-track": { backgroundColor: "#036BAD" },
                "& .MuiSlider-thumb": {
                  backgroundColor: "#036BAD",
                  border: "2px solid #036BAD",
                },
              }}
            />
          </div>

          <div>
            <AccessibleTooltip title="Zoom In">
              <button
                className="zoom_in"
                onClick={(e) => handleZoomIn(e, setZoomLevel, zoomLevel, setAnnouncement)}
                type="button"
                aria-label="Zoom In"
              ></button>
            </AccessibleTooltip>
          </div>

          <div>
            <AccessibleTooltip title="Fullscreen">
              <button
                id="fullScreenButton"
                className="fullscreen"
                onClick={() =>
                  handleFullScreen(floorMapRef, () => handleExitFullScreen(handleEscapeKey), handleEscapeKey)
                }
                type="button"
                aria-label="Enter Fullscreen"
              ></button>
            </AccessibleTooltip>
          </div>

          <div>
            <button onClick={() => handleResetZoom(setZoomLevel, setAnnouncement)} className="reset-zoom">
              Reset Zoom
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

Footer.propTypes = {
  floorMapRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  currentFloor: PropTypes.string,
  expand: PropTypes.bool,
  isDynamicFooter: PropTypes.bool,
  carouselItems: PropTypes.array,
};

export default Footer;
